import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Grid, useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

import Logout from "../../../common/Logout";
import CustomApplePayButton from "../../../common/CustomApplePayButton";
import CustomGooglePayButton from "../../../common/CustomGooglePayButton";
import CustomSlider from "../../../common/CustomSlider";
import AfterPurchaseMessage from "../components/AfterPurchaseMessage";
import AppLoadingScreen from "../../../common/AppLoadingScreen";
import CustomButton from "../../../common/CustomButton";
import PBCardDetails from "../components/PBCardDetails";
import CustomModalWrapper from "../../../common/CustomModalV2/wrapper";
import PurchaseFormFooter from "../components/PurchaseFormFooter";
import IndiPlans from "../components/IndiPlans";

import { CreatePurchase, CreatePurchaseDirect, GetPlanSaleInfo } from "../../../redux/v2/plan/actions";
import { LoadUserBillingData, LoadAccountDetails } from "../../../redux/v2/user/actions";
import { SetModalProperties, ShowModal } from "../../../redux/v2/utils/actions";
import { calculateDateFromTrialPeriodFormat, validations } from "../../../constants";
import { ScreenType } from "../../../utils/breakpoints";

import "./style.css";

function SalePlan(props) {
    const navigate = useNavigate();
    const dt = localStorage.getItem("indi-device-type");
    const saleID = new URLSearchParams(window.location.search).get("sale-id") || localStorage.getItem("sale-id");

    const [loaded, setLoaded] = useState(false);
    const [saleDetails, setSaleDetails] = useState(null);
    const [saleStatus, setSaleStatus] = useState(0); // -1, 0, 1

    const [selectedPlan, setSelectedPlan] = useState({});
    const [filteredPlan, setFilteredPlan] = useState([]);
    const [showPostMessage, setShowPostMessage] = useState(false);

    const screenSize = ScreenType(useMediaQuery);

    useEffect(() => {
        const cb = async () => {
            const res = await props.GetPlanSaleInfo(saleID);
            if (res?.success) {
                setSaleStatus(1);
                setSaleDetails(res?.data?.sale);
                setFilteredPlan(res?.data?.planOptions);
                setSelectedPlan(res?.data?.planOptions[0]);
            } else {
                setSaleStatus(-1);
                navigate("/choose-plan");
            }
            setLoaded(true);
        };
        cb();
    }, []);

    const postPurchase = async (toastId, formDetails = null) => {
        // props.LoadUserBillingData();
        const res2 = await props.LoadAccountDetails();

        props.ShowModal(false);
        toast.success("Plan subscribed successfully", {
            id: toastId,
        });

        localStorage.setItem("requirement_status", 3);
        localStorage.setItem("survey_not_done", true);

        if (formDetails) {
            localStorage.setItem(
                "indi-new-user-details",
                JSON.stringify({
                    name: {
                        first: formDetails?.firstName,
                        last: formDetails?.lastName,
                    },
                })
            );
        }

        setShowPostMessage(!showPostMessage);
    };

    const onSubmit = async ({ err, token, formDetails, toastId }) => {
        if (err) {
            if (err?.message) {
                var lastIndex = err.message.lastIndexOf(" ");
                let str = err.message.substring(0, lastIndex);
                let errmessage = str + " " + err.details[0].field;
                toast.error(errmessage, {
                    id: toastId,
                });
            }
        } else {
            let couponArr = [];
            let coupon_code = localStorage.getItem("coupon_code");
            let createPurchaseObj = {
                first_name: formDetails?.firstName,
                last_name: formDetails?.lastName,
                currency: "USD",
                rjs_token: token.id,
                plan_id: selectedPlan.id,
                billing_zip: formDetails?.postalCode,
                coupon_code: couponArr,
                renewal: false,
            };

            let res = await props.CreatePurchase(createPurchaseObj, selectedPlan);

            if (res.status == 200) {
                postPurchase(toastId, formDetails);
            } else {
                toast.dismiss(toastId);
            }
        }
    };

    const onSubmitUsingApplePay = async (token) => {
        const toastId = toast.loading("Creating purchase...");

        let coupon_code = localStorage.getItem("coupon_code") || [];
        let createPurchaseObj = {
            currency: "USD",
            rjs_token: token.id,
            plan_id: selectedPlan.id,
            coupon_code: coupon_code,
        };

        let res = await props.CreatePurchaseDirect(createPurchaseObj, selectedPlan);

        if (res.status == 200) {
            postPurchase(toastId);
        } else {
            toast.dismiss(toastId);
        }
    };

    const onSubmitUsingGooglePay = async (token) => {
        const toastId = toast.loading("Creating purchase...");

        let coupon_code = localStorage.getItem("coupon_code") || [];

        const plan = JSON.parse(localStorage.getItem("current-selected-plan"));

        let createPurchaseObj = {
            currency: "USD",
            rjs_token: token.id,
            plan_id: plan.id,
            coupon_code: coupon_code,
        };

        let res = await props.CreatePurchaseDirect(createPurchaseObj, plan);

        if (res.status == 200) {
            postPurchase(toastId);
        } else {
            toast.dismiss(toastId);
        }
    };

    let trialEnd = calculateDateFromTrialPeriodFormat(selectedPlan?.trial_length, selectedPlan?.trial_unit);

    const uri = process.env.REACT_APP_ENVIRONMENT == "PROD" ? process.env.REACT_APP_BASE_API_URL : process.env.REACT_APP_BASE_API_URL_DEV;

    return !loaded ? (
        <AppLoadingScreen />
    ) : (
        <div id="ip-sale-plan" className="plan-v2-css">
            <Logout showLogo={true} />

            <div id="plan-billing-banner" hidden={screenSize == "xl"}>
                <img className="Plan Sale Banner" src={`${uri}images/sale_banner/${saleDetails?.banner}`} />
            </div>

            <Grid container spacing={0}>
                <Grid item xs={screenSize != "xl" ? 12 : 6} style={{ display: "flex", justifyContent: "center" }}>
                    <div style={{ maxWidth: "450px" }}>
                        <div id="plan-billing-banner-text">
                            <h3>{saleDetails?.title}</h3>
                            <p>{saleDetails?.description}</p>
                        </div>
                        <div className="auth-box" style={{ padding: "0 30px 50px 30px" }}>
                            <div className="container">
                                <IndiPlans plans={filteredPlan} selectedPlan={selectedPlan} setSelectedPlan={setSelectedPlan} isSale={true} />

                                <h4>CHOOSE PAYMENT METHOD</h4>

                                <div id="card-payment-div">
                                    <CustomButton
                                        onClick={() => {
                                            props.SetModalProperties({
                                                isShow: true,
                                                title: "",
                                                body: (
                                                    <>
                                                        <PBCardDetails
                                                            selectedPlan={selectedPlan}
                                                            callback={(response) => {
                                                                onSubmit({
                                                                    ...response,
                                                                });
                                                            }}
                                                        />
                                                    </>
                                                ),
                                                actions: [],
                                            });
                                        }}
                                    >
                                        Pay with Credit Card
                                    </CustomButton>
                                </div>

                                {dt === "ios" && (
                                    <div id="payment-provider-div">
                                        <CustomApplePayButton
                                            plan={selectedPlan}
                                            applePayCallButtonback={(token) => {
                                                onSubmitUsingApplePay(token);
                                            }}
                                        />
                                    </div>
                                )}

                                <div id="payment-provider-div">
                                    <CustomGooglePayButton
                                        plan={selectedPlan}
                                        googlePayCallButtonback={(token) => {
                                            onSubmitUsingGooglePay(token);
                                        }}
                                    />
                                </div>

                                <PurchaseFormFooter selectedPlan={selectedPlan} endDate={trialEnd} />
                            </div>
                        </div>
                    </div>
                </Grid>
                <Grid item xs={6}>
                    <div id="plan-billing-banner" hidden={screenSize != "xl"} style={{ height: "100%" }}>
                        <img className="Plan Sale Banner" src={`${uri}images/sale_banner/${saleDetails?.banner}`} />
                    </div>
                </Grid>
            </Grid>

            <CustomSlider
                showCloseButton={false}
                show={showPostMessage}
                setShowSlider={() => {
                    setShowPostMessage(!showPostMessage);
                }}
            >
                <AfterPurchaseMessage
                    onClick={() => {
                        navigate("/");
                    }}
                />
            </CustomSlider>

            <CustomModalWrapper />
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    GetPlanSaleInfo,
    CreatePurchase,
    CreatePurchaseDirect,
    SetModalProperties,
    ShowModal,
    LoadUserBillingData,
    LoadAccountDetails,
})(SalePlan);
